import React from "react";
import { Modal, ModalBody, Button, FormGroup, Input } from "reactstrap";
import { useVendor } from "../Store/VendorStore";
import { sendRatingMessage } from "../Store/RatingApi";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Spinner from "react-bootstrap/Spinner";
import { useLocation } from "react-router-dom";

const RateVendorModal = ({ isOpen, toggle }) => {
  const { vendorData, reviews, fetchVendorDetails } = useVendor();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const vendorIdFromUrl = query.get("vendor_profiles_id");
  const userIdFromUrl = query.get("userId");

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Name is required")
      .min(2, "Name must be at least 2 characters"),
    contact: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    message: Yup.string().required("Message is required"),
  });

  const handleSubmit = async (values) => {
    const payload = {
      vendor_profile_Id: vendorData.id,
      name: values.name,
      contact_info: values.contact,
      rating: values.rating,
      review: values.message,
      user_Id: vendorData.users_id,
    };
    try {
      const response = await sendRatingMessage(payload);

      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Message Sent!",
          text: response.message,
          confirmButtonColor: "#3C3C3C",
          zIndex: 10000,
          showConfirmButton: false,
        });
        toggle();

        // Refresh vendor data to update reviews after submission
        const vendorId = vendorIdFromUrl || vendorData.id;
        const userId = userIdFromUrl || undefined;
        await fetchVendorDetails(vendorId, userId);
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.message,
          confirmButtonColor: "#3C3C3C",
          zIndex: 10000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error("Error submitting rating:", error);
      toast.error("Error submitting rating");
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} toggle={toggle} backdrop="static">
        <button
          type="button"
          className="close"
          aria-label="Close"
          onClick={toggle}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "2rem",
            cursor: "pointer",
            position: "absolute",
            top: "10px",
            right: "20px",
          }}
        >
          &times;
        </button>
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            margin: "20px 20px 0 20px",
            flexDirection: "column",
            padding: "10px 41px",
          }}
        >
          <img
            style={{
              borderRadius: "50%",
              height: "200px",
              width: "200px",
              margin: "0 auto",
              display: "block",
            }}
            src={vendorData.Profile_Image?.url}
            alt="Vendor Profile"
          />
          <h2
            className="Pheading"
            style={{ fontWeight: "700", marginTop: "15px" }}
          >
            {vendorData.Name || "Vendor Name"}
          </h2>
          <h5
            style={{ fontWeight: "700", marginTop: "20px", fontSize: "1.2rem" }}
          >
            RATE THIS VENDOR
          </h5>
          <h6
            className="text-start"
            style={{ fontWeight: "400", marginTop: "20px" }}
          >
            Love this vendor? Leave a review and rating below to spread the
            word!
          </h6>
        </div>
        <ModalBody style={{ padding: "10px 41px" }}>
          <Formik
            initialValues={{ name: "", contact: "", message: "", rating: 0 }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ setFieldValue, values, isSubmitting }) => (
              <Form>
                <div className="text-center mb-3">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <span
                      key={star}
                      style={{
                        cursor: "pointer",
                        fontSize: "3rem",
                        color: star <= values.rating ? "#FFD700" : "#e4e5e9",
                      }}
                      onClick={() => setFieldValue("rating", star)}
                    >
                      ★
                    </span>
                  ))}
                </div>
                <FormGroup>
                  <Field
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Name"
                    as={Input}
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="text-danger"
                  />
                </FormGroup>
                <FormGroup>
                  <Field
                    type="text"
                    name="contact"
                    id="contact"
                    placeholder="Email"
                    as={Input}
                  />
                  <ErrorMessage
                    name="contact"
                    component="div"
                    className="text-danger"
                  />
                </FormGroup>
                <FormGroup>
                  <Field
                    type="textarea"
                    name="message"
                    id="message"
                    placeholder="Some message to the vendor..."
                    as={Input}
                  />
                  <ErrorMessage
                    name="message"
                    component="div"
                    className="text-danger"
                  />
                </FormGroup>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    marginBottom: "40px",
                  }}
                >
                  <Button
                    style={{
                      background: "#3C3C3C",
                      width: "80%",
                      height: "48px",
                    }}
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <Spinner
                          animation="border"
                          variant="light"
                          size="sm"
                          style={{ marginRight: "5px" }}
                        />
                        Sending...
                      </>
                    ) : (
                      "SUBMIT RATING"
                    )}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </ModalBody>
      </Modal>
      {/* <ToastContainer
        position="top-right"
        autoClose={1200}
        hideProgressBar
        newestOnTop={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        pauseOnHover={false}
        theme="light"
      /> */}
    </>
  );
};

export default RateVendorModal;
